import React, {Component} from 'react';
import SummaryChart from "../SummaryChart";
import {connect} from "react-redux";
import {compose} from "redux";
import {withRouter} from "react-router";
import {getProjectRfiStatusReport} from "../../../actions/reports";
import {buildSummaryChartData} from "../../../projections";
import * as PropTypes from "prop-types";
import {subdocumentStatusReportSelector} from "../selectors";

class RfiSummary extends Component {
  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  render() {
    const { summary, title, onClick } = this.props;
    const chartData = buildSummaryChartData(summary);
    return (
      <SummaryChart
        title={title}
        data={chartData}
        onClick={onClick}
      />
    );
  }
}

RfiSummary.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default compose(
  withRouter,
  connect(
    (state, props) => ({
      summary: subdocumentStatusReportSelector(state, { path: 'projectrfis', code: 'projectrfistatus' })
    }),
    (dispatch, props) => ({
      onMount: () => dispatch(getProjectRfiStatusReport({id: props.match.params.id}))
    })
  )
)(RfiSummary);



// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/RfiSummary.js